<template>
  <div>
    <section>
      <v-dialog v-model="dialog.areyousure"
        @keydown.esc="dialog.areyousure = false"
        width="300"
        persistent
        scrollable>
        <v-card 
          class="pa-2 border-radius">
          <v-card-text class="body-1 font-weight-light text-first mt-3">
            Are you sure you want to {{ !is_emergency ? 'activate' : 'deactivate' }} emergency mode?
          </v-card-text>

          <v-divider class="mx-4 mb-3 mt-0"/>

          <v-card-actions>
            <v-spacer/>

            <v-btn
              @click="saveUpdateSos()"
              :disabled="process.form"
              :loading="process.form"
              
              color="green"
              elevation="0"
              style="border-radius: 10px;"
              class="body-2 font-weight-bold text-capitalize white--text">
              <v-icon small class="mr-1">mdi-check-bold</v-icon>
              Yes, I am sure
            </v-btn>

            <v-btn
              @click="dialog.areyousure = false"
              :disabled="process.form"

              outlined
              style="border-radius: 10px;"
              class="body-2 font-weight-bold text-capitalize red--text">
              <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
              Cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-app-bar
        :clipped-left="clipped"
        color="#EBEBEB"
        fixed
        nav
        elevation="0"
        app
        :class="clipped ? 'clipped' : ''"
        style="border-radius: 0px; z-index: 9;">
        <v-app-bar-nav-icon class="hidden-lg-and-up" @click.stop="drawer = !drawer"/>
        
        <v-toolbar-title 
          class="d-flex align-center"
          :class="clipped ? 'pl-1' : ''">
          <div v-if="clipped"
            class="mr-8">
            <v-img
              @click="clipped = false"
              contain
              width="40"
              height="40"
              alt="tvandroid"  
              :src="require('@/assets/logo/logo_mini.png')"
              class="ma-auto cursor-pointer">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    size="20"
                    indeterminate 
                    :color="set_color">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </div>
          
          <v-chip
            to="/order"
            color="#0786BE"
            class="mr-6"
            style="width: 146px; height: 43px; border-radius: 50px;">
            <span
              class="body-2 white--text ml-1"
              style="font-weight: 600;">
              Food Order
            </span>

            <v-spacer />

            <v-avatar
              class="body-2"
              color="#FFEB3B"
              style="position: absolute; right: 12px; color: #686868;">
              {{ counter.total_food_order_waiting }}
            </v-avatar>
          </v-chip>
          
          <v-chip
            to="/service"
            color="#FFFFFF"
            style="width: 187px; height: 43px; border-radius: 50px;">
            <span
              class="body-2 ml-1"
              style="font-weight: 600; color: #686868;">
              Services Request
            </span>

            <v-spacer />

            <v-avatar
              class="body-2"
              color="#EBEBEB"
              style="position: absolute; right: 12px; color: #686868;">
              {{ counter.total_service_request_waiting }}
            </v-avatar>
          </v-chip>
        </v-toolbar-title>

        <v-spacer/>

        <div v-if="status_interval === 'ENABLE'"
          class="mr-4">
          <v-img
            @click="dialog.areyousure = true"

            contain
            width="28"
            height="28"
            alt="tvandroid"  
            :src="require('@/assets/icon/siren.png')"
            class="ma-auto cursor-pointer"
            :style="!is_emergency ? 'filter: grayscale(100%);' : ''">
            <template v-slot:placeholder>
              <v-row
                class="fill-height"
                align="center"
                justify="center">
                <v-progress-circular 
                  size="20"
                  indeterminate 
                  :color="set_color">
                </v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </div>

        <v-menu
          transition="slide-x-transition"
          bottom
          right
          offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-list 
              flat 
              dense
              color="transparent"
              style="max-width: 200px;">
              <v-list-item 
                v-bind="attrs"
                v-on="on"
                class="px-2"
                style="border-radius: 50px; background: #FFFFFF;">
                <v-list-item-avatar 
                  size="30"
                  tile
                  style="border-radius: 5px !important;">
                  <v-img 
                    width="100%"
                    height="auto"
                    alt="tvandroid"  
                    :src="require('@/assets/image/member_default.png')"
                    class="ma-auto">
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center">
                        <v-progress-circular 
                          size="20"
                          indeterminate 
                          :color="set_color">
                        </v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title
                    class="body-2 font-weight-bold">
                    {{ user.user_full_name }}
                  </v-list-item-title>
                </v-list-item-content>

                <v-list-item-action>
                  <v-icon>mdi-menu-down</v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </template>

          <v-list>
            <v-list-item
              v-for="(item, index) in menu.right"
              :key="index"
              @click="toMenu(item)">
              <v-list-item-content
                :style="index < menu.right.length - 1 ? 'border-bottom: 2px solid #f9f9f9;' : ''">
                <v-list-item-title>
                  {{ item.title }}
                </v-list-item-title>
              </v-list-item-content>

            </v-list-item>
          </v-list>
        </v-menu>
      </v-app-bar>

      <v-navigation-drawer
        v-model="drawer"
        :mini-variant.sync="clipped"
        width="275"
        color="#FFFFFF"
        dark
        fixed
        app>
        <div
          class="d-flex align-center cursor-pointer pa-3 py-1 mb-4"
          style="height: 64px; background: #EBEBEB;">
          <div
            class="d-flex align-center">
            <div v-if="!clipped"
              class="d-flex align-center">
              <v-img
                contain
                width="160"
                height="40"
                alt="tvandroid"  
                :src="Object.keys(company).length > 0 ? company.logo : require('@/assets/logo/logo_color.png')"
                class="ma-auto ml-1">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      size="20"
                      indeterminate 
                      :color="set_color">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </div>

            <v-spacer v-if="!clipped" />

            <v-btn v-if="!clipped"
              @click="clipped = !clipped ? true : false"
              class="mr-3"
              style="position: absolute; right: 0;"
              icon>
              <v-icon
                color="black">
                mdi-chevron-left
              </v-icon>
            </v-btn>
          </div>
        </div>

        <v-list
          style="height: calc(100vh - 100px); overflow-y: auto; overflow-x: hidden;">
          <div 
            v-for="(item, index) in menu.left"
            :key="index">
            <v-list-item 
              v-if="item.sub_menu.length < 1 && item.type === 'parent'"
              :to="item.link" 
              color="transparent"
              :class="clipped ? 'px-2' : ''">
              <v-list-item-avatar
                size="40"
                tile
                class="mr-4"
                :class="item.link.split('/')[1] === $route.fullPath.split('/')[1] ? '' : 'box_false'"
                :color="item.link.split('/')[1] === $route.fullPath.split('/')[1] ? '#C8EEFF' : '#FFFFFF'"
                :style="item.link.split('/')[1] === $route.fullPath.split('/')[1] ? `border: 2px solid ${set_color};` : ''"
                style="border-radius: 10px !important;">
                <v-img 
                  contain
                  width="22"
                  height="22"
                  alt="tvandroid"  
                  :src="item.icon"
                  class="ma-auto">
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height"
                      align="center"
                      justify="center">
                      <v-progress-circular 
                        size="20"
                        indeterminate 
                        :color="set_color">
                      </v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title
                  class="body-2"
                  :class="item.link.split('/')[1] === $route.fullPath.split('/')[1] ? '' : 'grey--text'"
                  :style="item.link.split('/')[1] === $route.fullPath.split('/')[1] ? `color: ${set_color}; font-weight: 600;` : ''">
                  {{ item.title }} 
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-group
              v-if="item.sub_menu.length > 0 && item.type === 'parent_sub'"
              v-model="item.active"
              :color="set_color"
              no-action
              class="px-0"
              :class="clipped ? 'clipped_header' : ''">
              <template v-slot:activator>
                <v-list-item-avatar
                  size="40"
                  tile
                  class="mr-4"
                  :class="item.active ? '' : 'box_false'"
                  :color="item.active ? '#C8EEFF' : '#FFFFFF'"
                  :style="item.active ? `border: 2px solid ${set_color};` : ''"
                  style="border-radius: 10px !important;">
                  <v-img 
                    contain
                    width="22"
                    height="22"
                    alt="amanata"  
                    :src="item.icon"
                    class="ma-auto">
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center">
                        <v-progress-circular 
                          size="20"
                          indeterminate 
                          :color="set_color">
                        </v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title
                    class="body-2"
                    :class="item.active ? 'font-weight-bold' : 'grey--text'"
                    :style="item.active === $route.fullPath ? `color: ${set_color};` : ''">
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item
                v-for="(item_sub, index_sub) in item.sub_menu"
                :key="index_sub"
                :to="item_sub.link"
                color="transparent">
                <v-list-item-content>
                  <v-list-item-title
                    class="body-2"
                    :class="item_sub.link === $route.fullPath ? 'font-weight-bold' : 'grey--text'"
                    :style="item_sub.link === $route.fullPath ? `color: ${set_color};` : ''">
                    {{ item_sub.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>

            <div
              v-if="item.sub_menu.length > 0 && item.type === 'parent_title'">
              <div
                class="body-1 black--text text-uppercase pa-4"
                style="font-weight: 600;">
                <span v-if="clipped">
                  <v-icon :color="set_color">mdi-cogs</v-icon>
                </span>
                
                <span v-else>
                  {{ item.title }}
                </span>
              </div>

              <v-list-item
                v-for="(item_sub, index_sub) in item.sub_menu"
                :key="index_sub"
                :to="item_sub.link"
                color="transparent"
                :class="clipped ? 'px-2' : ''">
                <v-list-item-avatar
                  size="40"
                  tile
                  class="mr-4"
                  :class="item_sub.link.split('/')[2] === $route.fullPath.split('/')[2] ? '' : 'box_false'"
                  :color="item_sub.link.split('/')[2] === $route.fullPath.split('/')[2] ? '#C8EEFF' : '#FFFFFF'"
                  :style="item_sub.link.split('/')[2] === $route.fullPath.split('/')[2] ? `border: 2px solid ${set_color};` : ''"
                  style="border-radius: 10px !important;">
                  <v-img 
                    contain
                    width="22"
                    height="22"
                    alt="tvandroid"  
                    :src="item_sub.icon"
                    class="ma-auto">
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center">
                        <v-progress-circular 
                          size="20"
                          indeterminate 
                          :color="set_color">
                        </v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-list-item-avatar>
                
                <v-list-item-content>
                  <v-list-item-title
                    class="body-2"
                    :class="item_sub.link === $route.fullPath ? '' : 'grey--text'"
                    :style="item_sub.link === $route.fullPath ? `color: ${set_color}; font-weight: 600;` : ''">
                    {{ item_sub.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </div>
          </div>
        </v-list>
      </v-navigation-drawer>
    </section>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        dialog: {
          areyousure: false
        },

        clipped: false,
        drawer: true,
        total: 0,
        menu: {
          right: [
            {
              title: 'Profile',
              type: 'profile',
              link: '/profile?menu=profile'
            },
            {
              title: 'Keluar',
              type: 'logout',
              link: '#'
            }
          ],
          left: []
        },

        counter: {
          total_food_order_waiting: 0,
          total_service_request_waiting: 0
        },
        countdown: 100000,

        status_interval: 'DISABLE',
        is_emergency: false,

        process: {
          form: false
        }
      }
    },
    components: {
      Empty: () => import(/* webpackPrefetch: true */ '@/components/empty')
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      token () {
        return this.$store.state.token
      },
      reload () {
        return this.$store.state.reload
      },
      company () {
        return this.$store.state.company
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r+93}, ${g+120}, ${b+12})`
      },
      set_color_rgb_soft () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.05)`
      }
    },
    created () {
      
    },
    mounted () {
      const debounce = (fn) => {
        let frame;
        return (...params) => {
          if (frame) { 
            cancelAnimationFrame(frame)
          }
          frame = requestAnimationFrame(() => {
            fn(...params)
          })
        } 
      }

      const storeScroll = () => {
        document.documentElement.dataset.scroll = window.scrollY
      }

      document.addEventListener('scroll', debounce(storeScroll), { passive: true })
      storeScroll()

      this.menu.left = this.$store.state.menu

      let company = {
        company_name: 'VISUALITY',
        logo: require('@/assets/logo/logo_color.png')
      }

      TokenService.saveCompany(JSON.stringify(company))
      this.$store.commit("setCompany", company)

      TokenService.saveColor('#0786BE')
      this.$store.commit("setColor", '#0786BE')

      this.styles()

      this.re_req()

      this.fetchConfig()
    },
    methods: {
      async toMenu (item) {
        if (item.type === 'logout') {
          TokenService.removeToken()
              
          window.location = '/'
        } else {
          this.$router.push(item.link)
        }

        if (this.counter.total_food_order_waiting > 0 || this.counter.total_service_request_waiting > 0) this.sound()
      },

      styles () {
        let style = document.createElement('style')
          
        // RESET STYLESHEET TO AUTO
        style.innerHTML = `
          .v-data-table table .v-data-table-header {
            color: white;
            // background-color: ${this.set_color}; !important;
          }
          .v-data-table table > thead > tr > th {
            // background: ${this.set_color};
          }

          .v-data-table table > tbody .v-data-table__selected .v-input--selection-controls__input {
            // color: ${this.set_color};
          }
          .v-data-table table > tbody .v-input--selection-controls__input .v-icon {
            // color: ${this.set_color};
          }

          ::-webkit-scrollbar-thumb{
            border-radius: 10px;
            background-color: ${this.set_color};
          }

          #iw-container .iw-title {
            font-family: 'Open Sans Condensed', sans-serif;
            font-size: 22px;
            font-weight: 400;
            padding: 10px;
            background-color: ${this.set_color};
            color: white;
            margin: 0;
            border-radius: 2px 2px 0 0;
          }

          .v-slide-group__prev .v-icon {
            color: ${this.set_color}; !important;
          }

          .v-slide-group__next .v-icon {
            color: ${this.set_color}; !important;
          }

          .table-grid table > thead > tr > th:nth-child(1) {
            left: 0; 
            z-index: 5;
            // background: ${this.set_color};
          }

          .v-data-table table > tbody > tr:hover .text-start, table > tbody > tr:hover .text-center,  table > tbody > tr:hover .text-end {
            cursor: pointer;
            // background-color: ${this.set_color_rgb_up} !important;
            background-color: #E0E0E0 !important;
            border-radius: 0px !important;
          }
          .v-data-table__selected .text-start, .v-data-table__selected .text-center, .v-data-table__selected .text-end {
            // background-color: ${this.set_color_rgb_up} !important;
            background-color: #E0E0E0 !important;
            border-radius: 0px !important;
          }
        `

        // ADD TO APPENDCHILD
        document.head.appendChild(style)
      },

      async fetchCounter () {
        await get(`admin/dashboard/counter-waiting`)
        .then(response => {
          let res = response.data
            
          if (res.code === 200) {
            this.counter = res.result

            if (this.counter.total_food_order_waiting > 0 || this.counter.total_service_request_waiting > 0) this.sound()
          }
        })
      },

      re_req () {
        this.fetchCounter()

        this.countdown--

        if (this.countdown > 0) {
          setTimeout(this.re_req, 60000)
        }
      },

      sound () {
        let audio = new Audio(require('@/assets/ringtone/bell.wav'))
        
        audio.play()
      },

      async fetchConfig () {
        let params = {
          key: 'EMERGENCY_MODE_JSON'
        }

        await get(`admin/config/detail`, { params })
        .then(response => {
          let res = response.data
            
          if (res.code === 200) {
            this.status_interval = res.result.data.EMERGENCY_MODE_JSON.value_object.status
            if (this.status_interval === 'ENABLE') {
              this.fetchConfigSos()
            }
          }
        })
      },

      async fetchConfigSos () {
        let params = {
          key: 'IS_EMERGENCY'
        }

        await get(`admin/config/detail`, { params })
        .then(response => {
          let res = response.data
            
          if (res.code === 200) {
            this.is_emergency = eval(res.result.data.IS_EMERGENCY.value)
          }
        })
      },

      async saveUpdateSos () {
        this.process.form = true

        let form_config = [{
          key: 'IS_EMERGENCY',
          value: (!this.is_emergency).toString()
        }]

        // SAVE TO REST API
        await post(`admin/config/update`, {
          data: {
            config: form_config
          }
        })
        .then((response) => {
          let res = response.data

          if (res.code === 200) {
            this.process.form = false

            this.dialog.areyousure = false

            this.fetchConfigSos()
          }
        })
      }
    }
  }
</script>

<style>
  .sub .v-list-item {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }

  .clipped .v-toolbar__content {
    padding-left: 8px;
  }

  .v-navigation-drawer--mini-variant {
    width: 68px !important;
  }

  .clipped_header .v-list-group__header {
    padding: 0px 8px;
  }
</style>